import { useEffect, useRef } from 'react';
import { getChatConfig } from '@/config/chatConfig';
import { loadRemoteConfig } from '@/utils/supabaseConfig';

export const ChatWootWidget = (): JSX.Element | null => {
  const scriptRef = useRef<HTMLScriptElement | null>(null);

  useEffect(() => {
    const initializeChatWoot = async () => {
      console.group('Initializing ChatWoot Widget');
      
      // Load remote config first
      await loadRemoteConfig();
      
      // Get the latest config values
      const config = getChatConfig();
      
      console.log('ChatWoot Configuration:', {
        enabled: config.enabled,
        baseUrl: config.baseUrl,
        websiteToken: config.enabled ? '***' + config.websiteToken.slice(-4) : 'disabled'
      });

      if (!config.enabled) {
        console.log('ChatWoot is disabled, skipping initialization');
        console.groupEnd();
        return;
      }

      // Check if script is already loaded
      if (scriptRef.current) {
        console.log('ChatWoot script already loaded, skipping initialization');
        console.groupEnd();
        return;
      }

      console.log('Loading ChatWoot SDK...');
      const script = document.createElement('script');
      script.src = `${config.baseUrl}/packs/js/sdk.js`;
      script.defer = true;
      script.async = true;
      script.onload = () => {
        console.log('ChatWoot SDK loaded, initializing widget...');
        window.chatwootSDK?.run(config);
      };
      document.body.appendChild(script);
      scriptRef.current = script;

      console.groupEnd();
    };

    initializeChatWoot();

    return () => {
      console.group('Cleaning up ChatWoot widget');
      if (scriptRef.current) {
        document.body.removeChild(scriptRef.current);
        scriptRef.current = null;
      }
      console.groupEnd();
    };
  }, []);

  return null;
};